const GRID_FLOOR_SIDEBAR_ID = "world-grid-floor";

function createGridFloorSidebarItem(options = {}) {
  const { visible = true, onToggle = () => {} } = options;

  return {
    type: "WORLD_GRID",
    id: GRID_FLOOR_SIDEBAR_ID,
    shortID: GRID_FLOOR_SIDEBAR_ID,
    name: "Grid Floor",
    visibility: visible ? "all" : "none",
    visibilityHandler: onToggle,
    sortable: false,
    expandable: false,
    nestedSettings: true,
    pinnedPosition: "bottom",
  };
}

function getSidebarItemsWithGridFloor(groups = [], options = {}) {
  return [createGridFloorSidebarItem(options), ...groups];
}

export { GRID_FLOOR_SIDEBAR_ID, createGridFloorSidebarItem, getSidebarItemsWithGridFloor };
